import request from '@/utils/request'

// 解包：接口正常返回 result.data（纯业务数据），失败返回 error
// 注意：接口可能仅返回 {code:0,msg:"success"} 而无 data 字段，此时 result 返回空对象，避免 undefined 导致访问出错
function unwrap(promise) {
  return promise.then(({ result, error }) => {
    if (error) return { error, result: null }
    if (!result || result.code !== 0) {
      return { result: null, error: result || {} }
    }
    return { result: result.data === undefined || result.data === null ? {} : result.data, error: null }
  })
}

// WizarPOS / PAX / Qingo 进件表单提交（保存草稿 status=9，正式提交不带 status）
export function submitWizarOnboarding(data) {
  return unwrap(
    request({
      url: '/register/v2',
      method: 'POST',
      data,
    })
  )
}

// 查询当前商户可选 POS
export function getPosOptions() {
  return unwrap(
    request({
      url: '/register/pos_options/v1',
      method: 'GET',
    })
  )
}

// 确认已有 MID
export function confirmMerchantMid(applyNo, data) {
  return unwrap(
    request({
      url: `/register/${applyNo}/v2`,
      method: 'PUT',
      data,
    })
  )
}

// 查询进件详情/校验
export function getRegisterDetails(data) {
  return unwrap(
    request({
      url: '/register/details/v2',
      method: 'GET',
      params: data,
    })
  )
}

// 更新已有 MID
export function updateRegisterMid(data) {
  return unwrap(
    request({
      url: '/register/mid/v2',
      method: 'PUT',
      data,
    })
  )
}

// 查询州/省列表
export function getApplicationStates(data = { country_code: 'US' }) {
  return unwrap(
    request({
      url: '/region/states/v1',
      method: 'GET',
      params: data,
    })
  )
}

// 获取默认采购发票/运营地址证明
export function getDefaultPurchaseInvoice() {
  return unwrap(
    request({
      url: '/register/default_purchase_invoice/v1',
      method: 'GET',
    })
  )
}
